import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ba18fcf4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "loadingBox"
};
const _hoisted_2 = {
  key: 0,
  class: "select-radio"
};
const _hoisted_3 = {
  class: "select-radio_des"
};
const _hoisted_4 = {
  key: 1,
  class: "select-radio"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "自定义", -1));

const _hoisted_6 = {
  key: 2,
  class: "permissionTree"
};
const _hoisted_7 = {
  key: 3,
  class: "divider"
};
const _hoisted_8 = {
  key: 2,
  class: "permissionTree"
};
import { NTree, NSpace, NRadio, useMessage } from 'naive-ui';
import { ref, onBeforeMount, computed } from 'vue';
import { getNavInfo, updateSubPerm2Inherit } from '@teams/common/api';
import aclRules from '@teams/common/acl/aclRules';
import { useAcl } from 'vue-simple-acl';
import { useRoleStore } from '../../store/role';
import { useGroupStore } from '../../store/group';
import { useNavigatorStore } from '../../store/navigator';
import { useDebounceFn } from '@vueuse/core';
import Loading from '@teams/common/components/loading';
import handleResponseError from '@teams/common/hooks/useResponseError';
export default /*#__PURE__*/_defineComponent({
  __name: 'SetPermissionDialog',
  props: {
    navId: null,
    appId: null
  },

  setup(__props) {
    const props = __props; // 设置可见性信息

    const message = useMessage();
    const loading = ref(true);
    const isLeaf = ref(false); // 是否为子节点

    const isRoot = ref(false);
    const navRolePerms = ref([]);
    const fatherNavRolePerms = ref([]);
    const appRolePerms = ref([]);
    const parentNames = computed(() => {
      return getVisibleGroupOrRoleNames(roleTreeNodes.value, fatherNavRolePerms.value);
    });
    const navigatorStore = useNavigatorStore();
    const roleStore = useRoleStore();
    const roles = ref(roleStore.list.filter(role => [1, 2].includes(role.category)));
    const acl = useAcl();
    const specialRoleTreeKeys = {
      insideGroup: -1,
      outsideGroup: -2
    };
    const groupStore = useGroupStore();
    const isCustomPermission = ref(true); // 初始化nav详情

    const initNavInfo = async () => {
      const {
        data
      } = await getNavInfo(groupStore.groupId, props.navId);
      navRolePerms.value = data.role_perms.map(item => item.role_id);
      const parentId = data.parent_id;
      isLeaf.value = data.leaf;
      isRoot.value = parentId === 0;
      isCustomPermission.value = data.custom_perms;

      if (parentId !== 0) {
        const {
          data
        } = await getNavInfo(groupStore.groupId, parentId);
        fatherNavRolePerms.value = data.role_perms.map(item => item.role_id);
      }

      loading.value = false;
    };

    const changeNavPermission = keys => {
      navRolePerms.value = keys;
      setNavPermissionDebouncedFn();
    };

    const setNavPermissionDebouncedFn = useDebounceFn(() => {
      setNavPermission();
    }, 1000);

    const setNavPermission = async () => {
      const params = {
        nav_update_type: isCustomPermission.value ? 3 : 2,
        nav_role_perms: navRolePerms.value.map(item => {
          return {
            perms: ['view'],
            role_id: item
          };
        })
      };
      await navigatorStore.updateAppLink(props.navId, params);
    };

    const handleChange = async e => {
      const value = e.target.value;

      if (value === '0') {
        isCustomPermission.value = false;
        setPermissionInheritDebouncedFn();
      }

      if (value === '1') {
        isCustomPermission.value = true;
      }

      console.log(value);
    };

    const setPermissionInheritDebouncedFn = useDebounceFn(() => {
      setPermissionInherit();
    }, 1000);

    const setPermissionInherit = async () => {
      const params = {
        nav_update_type: 1,
        nav_role_perms: navRolePerms.value.map(item => {
          return {
            perms: ['view'],
            role_id: item
          };
        })
      };
      await navigatorStore.updateAppLink(props.navId, params);
    };

    const setSubPermInheritParent = () => {
      updateSubPerm2Inherit(groupStore.groupId, props.navId).then(() => {
        message.success('应用成功，子标签页已继承当前页面的权限');
      }).catch(error => {
        handleResponseError(error);
      });
    }; //  初始化app详情


    const initAppInfo = async () => {
      const {
        data
      } = await getNavInfo(groupStore.groupId, props.appId);
      appRolePerms.value = data.role_perms.map(item => item.role_id);
      loading.value = false;
    };

    const changeAppPermission = keys => {
      appRolePerms.value = keys;
      setAppPermissionDebouncedFn();
    };

    const setAppPermissionDebouncedFn = useDebounceFn(() => {
      setAppPermission();
    }, 1000);

    const setAppPermission = async () => {
      const params = {
        nav_update_type: 3,
        nav_role_perms: appRolePerms.value.map(item => {
          return {
            perms: ['view'],
            role_id: item
          };
        })
      };
      await navigatorStore.updateAppLink(props.appId, params);
    }; // 渲染角色下拉


    const roleTreeNodes = computed(() => {
      return rolesToTreeOption(roles.value, role => !acl.can(aclRules.navigation_update_role_visible, [role]));
    });

    function rolesToTreeOption(roles, checkboxDisabled) {
      const insideGroupRoleTreeNodes = roles.filter(role => role.category === 1).map(role => ({
        key: role.id,
        label: role.name,
        checkboxDisabled: checkboxDisabled?.(role),
        disabled: checkboxDisabled?.(role)
      }));
      const outsideGroupRoles = roles.filter(role => role.category === 2).map(role => ({
        key: role.id,
        label: role.name,
        checkboxDisabled: checkboxDisabled?.(role),
        disabled: checkboxDisabled?.(role)
      }));
      return [{
        key: specialRoleTreeKeys.insideGroup,
        label: '空间内成员',
        children: insideGroupRoleTreeNodes
      }, {
        key: specialRoleTreeKeys.outsideGroup,
        label: '空间外用户',
        children: outsideGroupRoles
      }];
    }

    function getVisibleGroupOrRoleNames(treeNodes, checkedIds, separator = '/') {
      const names = [];
      const idMap = checkedIds.reduce((prev, key) => {
        prev[key] = key;
        return prev;
      }, {});

      const walker = options => {
        for (const option of options) {
          const key = option.key;

          if (idMap[key]) {
            names.push(option.label);
          } else if (option.children) {
            walker(option.children);
          }
        }
      };

      walker(treeNodes);
      return names.join(separator);
    }

    onBeforeMount(() => {
      if (props.appId !== 0) {
        initAppInfo();
      } else {
        initNavInfo();
      }
    });
    return (_ctx, _cache) => {
      return loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Loading))])) : props.appId === 0 ? (_openBlock(), _createBlock(_unref(NSpace), {
        key: 1,
        vertical: "",
        class: "navPermission",
        size: 0
      }, {
        default: _withCtx(() => [!isRoot.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(NRadio), {
          checked: !isCustomPermission.value,
          value: "0",
          name: "perms",
          onChange: handleChange
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: _normalizeClass(!isCustomPermission.value ? 'select-radio_name' : '')
          }, " 继承上级标签页 ", 2), _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(parentNames)), 1)]),
          _: 1
        }, 8, ["checked"])])) : _createCommentVNode("", true), !isRoot.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_unref(NRadio), {
          value: "1",
          name: "perms",
          checked: isCustomPermission.value,
          onChange: handleChange
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }, 8, ["checked"])])) : _createCommentVNode("", true), isCustomPermission.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(NTree), {
          "block-line": true,
          selectable: "",
          checkable: "",
          cascade: "",
          "check-on-click": "",
          "check-strategy": "child",
          data: _unref(roleTreeNodes),
          "on-update:checked-keys": changeNavPermission,
          "expand-on-click": false,
          "checked-keys": navRolePerms.value,
          "default-expand-all": true
        }, null, 8, ["data", "checked-keys"])])) : _createCommentVNode("", true), !isLeaf.value ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : _createCommentVNode("", true), !isLeaf.value ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "select-radio_text",
          onClick: _cache[0] || (_cache[0] = () => setSubPermInheritParent())
        }, " 同时应用到子标签页 ")) : _createCommentVNode("", true)]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_unref(NTree), {
        "block-line": true,
        selectable: "",
        checkable: "",
        cascade: "",
        "check-on-click": "",
        "check-strategy": "child",
        data: _unref(roleTreeNodes),
        "on-update:checked-keys": changeAppPermission,
        "expand-on-click": false,
        "checked-keys": appRolePerms.value,
        "default-expand-all": true
      }, null, 8, ["data", "checked-keys"])]));
    };
  }

});